import { render, staticRenderFns } from "./GradientHeading.vue?vue&type=template&id=31df540f&scoped=true"
var script = {}
import style0 from "./GradientHeading.vue?vue&type=style&index=0&id=31df540f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31df540f",
  null
  
)

export default component.exports